import { createApi } from '@reduxjs/toolkit/query/react';

import type { ShortcutProfile } from '@app/utils/shortcuts';

import fetchBaseQuery from '../fetchBaseQuery';

const shortcutsApi = createApi({
    reducerPath: 'shortcuts',
    baseQuery: fetchBaseQuery(),
    tagTypes: [],
    endpoints: (builder) => ({
        getShortcutProfiles: builder.query<ShortcutProfile[], void>({
            query: () => ({
                method: 'GET',
                url: '/shortcuts',
            }),
        }),
    }),
});

export default shortcutsApi;

export const { useGetShortcutProfilesQuery, useLazyGetShortcutProfilesQuery } = shortcutsApi;
